<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">Додати інформацію</h2>
    </v-card-title>

    <v-card-content>
      <div class="mb-3">
        <v-text-field
          v-model="form.name"
          :label="'Інформація про модель'"
          :hint="errorMessage('name')"
          :invalid="!!errorMessage('name')"
        />
      </div>
      <div class="mb-3">
        <v-text-field
          v-model="form.calibration"
          :label="'Калібрування'"
          :hint="errorMessage('calibration')"
          :invalid="!!errorMessage('calibration')"
        />
      </div>
    </v-card-content>

    <v-card-actions>
      <v-btn :disabled="!isFormFilled" :loading="loading" @click="onCreate">{{ 'base.add' | translate }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'AddCalibrationModal',
  mixins: [formErrorsMixin],
  data () {
    return {
      form: {
        name: '',
        calibration: ''
      },
      errors: {
        name: null,
        calibration: null
      },
      loading: false
    }
  },

  computed: {
    isFormFilled () {
      return !!this.form.name && !!this.form.calibration
    }
  },

  methods: {
    async onCreate () {
      this.loading = true

      this.checkValidData()

      await new Promise(resolve => setTimeout(resolve, 300))
      if (this.errors.name === null && this.errors.calibration === null) {
        const calibrationData = {
          name: this.form.name.trim(),
          calibration: this.form.calibration.trim()
        }
        this.$emit('create', calibrationData)
        this.$emit('close')
      }

      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      this.errors.calibration = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
      if (!this.form.calibration) {
        this.errors.calibration = ['3']
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>
